/*
 * Reducer actions related with login
 */
import * as types from './types';

export function checkTerm(checkTerm) {
  return {
    type: types.CHECK_TERMS_CONDITIONS,
    checkTerm
  };
}

export function persistSignup(firstName, lastName, phone, email, password) {
  return {
    type: types.PERSIST_SIGNUP,
    firstName,
    lastName,
    phone,
    email,
    password
  };
}

export function requestSignup(accountRequest) {
  return {
    type: types.SIGNUP_REQUEST,
    accountRequest
  };
}

export function signupFailed(error) {
  return {
    type: types.SIGNUP_FAILED,
    error
  };
}

export function onSignupResponse() {
  return {
    type: types.SIGNUP_RESPONSE
  };
}

export function requestConfirmSignUp(email, code, password, phone, firstName, lastName) {
  return {
    type: types.CONFIRM_SIGNUP_REQUEST,
    email,
    code,
    password,
    phone,
    firstName,
    lastName
  };
}

export function resendCodeSignUp(email) {
  return {
    type: types.RESEND_CODE_REQUEST,
    email
  };
}
export function confirmSignUpFailed(error) {
  return {
    type: types.CONFIRM_SIGNUP_FAILED,
    error
  };
}

export function onConfirmSignUpResponse(response) {
  return {
    type: types.CONFIRM_SIGNUP_RESPONSE,
    response
  };
}

export function resendCodeSignUpFailed(error) {
  return {
    type: types.RESEND_CODE_FAILED,
    error
  };
}

export function onResendCodeSignUpResponse(response) {
  return {
    type: types.RESEND_CODE_RESPONSE,
    response
  };
}

export function setSignupActiveStep(signupActiveStep) {
  return {
    type: types.SET_SIGNUP_ACTIVE_STEP,
    signupActiveStep
  };
}
